import React from "react";

import type { MediaItem } from "../../media-widget/types/contexts";
import { usePlaylist } from "../../media-widget/hooks/usePlaylistContext";

interface ProgressBarProps {
  progress: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ progress }) => {
  const { mediaItems, currentMediaIndex, setCurrentMediaIndex } = usePlaylist();

  return (
    <div className="absolute top-0 z-20 m-4 flex w-[80%] justify-center gap-1 p-2">
      {mediaItems.map((_: MediaItem, index: number) => (
        <button
          key={index}
          onClick={() => setCurrentMediaIndex(index)}
          className="flex-1 overflow-hidden rounded-full bg-secondary"
          style={{ height: "0.25rem" }}
        >
          <div
            className="h-full bg-white transition-all duration-200"
            style={{
              width: `${index < currentMediaIndex ? 100 : index === currentMediaIndex ? progress : 0}%`,
            }}
          />
        </button>
      ))}
    </div>
  );
};

export default ProgressBar;
